import React from "react"
import PropTypes from "prop-types"
import { InputWrapper, IconWrapper } from "QuorumGrassroots/widgets/ReusableComponents/WithIcon/style"

interface WithIconProps {
    icon?: string
    IconComponent?: React.ElementType
    iconFamily?: string
    iconPosition?: "left" | "right"
    children: React.ReactNode
}

export const WithIcon = ({ icon, IconComponent, iconFamily, children, iconPosition = "right" }: WithIconProps) => {
    return (
        <InputWrapper position={iconPosition} id="with-icon-wrapper">
            {IconComponent && (
                <IconWrapper position={iconPosition}>
                    <IconComponent icon={icon} iconFamily={iconFamily} />
                </IconWrapper>
            )}
            {children}
        </InputWrapper>
    )
}

WithIcon.propTypes = {
    icon: PropTypes.string,
    IconComponent: PropTypes.elementType,
    iconFamily: PropTypes.string,
    iconPosition: PropTypes.oneOf(["left", "right"]),
    children: PropTypes.node.isRequired,
}
